import { useEffect, useState } from 'react';

import useServerDown from 'hooks/useServerDown';
import { Box } from '@mui/material';

type Props = {
	onScan: (code: string, serverIsDown: boolean) => void;
};

export const QRSCanner = ({ onScan }: Props) => {
	const [code, setCode] = useState('');

	const isDown = useServerDown();

	useEffect(() => {
		const handleKeyPress = async (event: KeyboardEvent) => {
			const char = event.key;

			if (/^[A-Z0-9]$/.test(char)) {
				setCode((prev) => (prev + event.key.toUpperCase()).slice(-8));
			}
			if (char === 'Enter' && code.length === 8) {
				onScan(code, isDown);
				setCode('');
			}
		};

		window.addEventListener('keydown', handleKeyPress);
		return () => {
			window.removeEventListener('keydown', handleKeyPress);
		};
	}, [code, isDown, onScan]);

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				color: 'white',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100%',
				backgroundColor: 'black',
			}}
		>
			<p>Esperando lectura de código QR...</p>
		</Box>
	);
};

export default QRSCanner;
